import { Routes } from '@angular/router';
import { userCollectionItemsRoutes } from './user-collection-items/user-collection-items.routes';
import { cardListRoutes } from './user-collection-items/card-list/card-list.routes';
import { tradeOptionsRoutes } from './trade-options/trade-options.routes';
import { userCollectionManageRoutes } from './user-collection-manage/user-collection-manage.routes';
import { tradeRequestsRoutes } from './trade-requests/trade-requests.routes';
import { collectionRankRoutes } from './collection-rank/collection-rank.routes';
import { displayCardsRoutes } from './user-collection-items/display-cards/display-cards.routes';
import { v2DisplayCardsRoutes } from './user-collection-items/v2-display-cards/v2-display-cards.routes';
import { v3DisplayCardsRoutes } from './user-collection-items/v3-display-cards/v3-display-cards.routes';

export const userCollectionRoutes: Routes = [
  {
    path: ':agent_id/:col_id/:user_col_id',
    loadComponent: () =>
      import('./user-collection.page').then((m) => m.UserCollectionPage),
    children: [
      {
        path: 'col-items',
        children: userCollectionItemsRoutes,
      },
      {
        path: 'trade-options',
        children: tradeOptionsRoutes,
      },
      {
        path: 'col-manage',
        children: userCollectionManageRoutes,
      },
      {
        path: 'trade-requests',
        children: tradeRequestsRoutes,
      },
      {
        path: 'collection-rank',
        children: collectionRankRoutes,
      } /*,
      {
        path: ':agent_id/:col_id/:user_col_id',
        redirectTo: '/user-collection/:agent_id/:col_id/:user_col_id/col-items',
        pathMatch: 'full'
          }*/,
    ],
  } /*,
  {
    path: ':agent_id/:col_id/:user_col_id',
    redirectTo: '/user-collection/:agent_id/:col_id/:user_col_id/col-items',
    pathMatch: 'full'
  }*/,
  {
    path: 'display-cards',
    children: displayCardsRoutes,
  },
  {
    path: 'v2-display-cards',
    children: v2DisplayCardsRoutes,
  },
  {
    path: 'v3-display-cards',
    children: v3DisplayCardsRoutes,
  },
];
